import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import GradualBlur from './components/GradualBlur';
import Hero from './components/sections/Hero';
import WhoIAm from './components/sections/WhoIAm';
import SelectedWorks from './components/sections/SelectedWorks';
import Solutions from './components/sections/Solutions';
import Process from './components/sections/Process';
import Awards from './components/sections/Awards';
import BookACall from './components/sections/BookACall';
import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
import Preloader from './components/Preloader';

function Home() {
  const { scrollYProgress } = useScroll();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Opacity goes from 1 to 0 when scroll is between 90% and 98%
  // This ensures it disappears before the footer fully takes over
  const blurOpacity = useTransform(scrollYProgress, [0.9, 0.98], [1, 0]);

  return (
    <div className="App relative">
      <Navbar />
      <main>
        <Hero />
        <WhoIAm />
        <SelectedWorks />
        <Solutions />
        <Process />
        <Awards />
        <BookACall />
      </main>

      
      <motion.div style={{ opacity: blurOpacity }}>
        <GradualBlur
          target="page"
          position="bottom"
          height="15vh"
          strength={isMobile ? 3 : 4}
          divCount={isMobile ? 4 : 8}
          curve="bezier"
          exponential={true}
          opacity={1}
          zIndex={1300}
        />
      </motion.div>

      <Footer />
    </div>
  );
}



function App() {
  const [loading, setLoading] = useState(true);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>

      <AnimatePresence>
        {loading && <Preloader onComplete={() => setLoading(false)} />}
      </AnimatePresence>
    </>
  );
}

export default App;
